import { apiFileUpload, apiRequest } from "util/services";

const absQuery = ({ isTest = false, archived = false } = {}) => {
  const parts = [];
  if (isTest) parts.push("is_test=true");
  if (archived) parts.push("archived=true");
  return parts.length ? `?${parts.join("&")}` : "";
};

export const listSegments = (isTest = false, archived = false) =>
  apiRequest(`abs/segments${absQuery({ isTest, archived })}`, "GET", null, true);
// Combined library: GET already returns both ai_discovered and manual origins.

export const listSegmentMembers = (segmentId) =>
  apiRequest(`abs/segments/${segmentId}/members`, "GET", null, true);

export const previewSegment = (payload) =>
  apiRequest("abs/segments/preview", "POST", payload || {}, true);

export const createSegment = (payload) =>
  apiRequest("abs/segments", "POST", payload || {}, true);

export const updateSegment = (segmentId, payload) =>
  apiRequest(`abs/segments/${segmentId}`, "PATCH", payload || {}, true);

export const restoreSegment = (segmentId) =>
  apiRequest(`abs/segments/${segmentId}`, "PATCH", { status: "restore" }, true);

export const archiveSegment = (segmentId) =>
  apiRequest(`abs/segments/${segmentId}`, "DELETE", null, true);

export const getAbsInsights = (isTest = false) =>
  apiRequest(`abs/insights${absQuery({ isTest })}`, "GET", null, true);

export const discoverSegments = (sources, isTest = false) =>
  apiRequest(
    "abs/discover",
    "POST",
    {
      ...(sources ? { sources } : {}),
      is_test: Boolean(isTest),
    },
    true
  );

export const getAnalysis = () => apiRequest("abs/analysis", "GET", null, true);

export const inspectDiscoveredAudience = (audienceId) =>
  apiRequest(
    `abs/analysis/audiences/${encodeURIComponent(audienceId)}`,
    "GET",
    null,
    true
  );

export const uploadAnalysisFile = async (file, onProgress) => {
  const res = await apiFileUpload("abs/analysis/upload", file, onProgress);
  if (!res) return { error: "Upload failed", status: "failed" };
  if (res.error_code === "ABS_ANALYSIS_TOO_LARGE") {
    return {
      ...res,
      status: "failed",
      error: res.error || res.error_code,
    };
  }
  if (res.status !== "ready") {
    return {
      ...res,
      error: res.error || res.error_code || "Upload failed",
    };
  }
  return res;
};

export const uploadTestCsv = async (file) => {
  const res = await apiFileUpload("abs/test-data/upload", file);
  if (!res) return { error: "Upload failed" };
  if (typeof res.accepted !== "number") {
    return {
      ...res,
      error: res.error || res.error_code || "Upload failed",
    };
  }
  return res;
};

export const clearTestData = () =>
  apiRequest("abs/test-data/clear", "POST", {}, true);

export const rerunAnalysis = () =>
  apiRequest("abs/analysis/rerun", "POST", {}, true);

export const getAbsSettings = () =>
  apiRequest("abs/settings", "GET", null, true);

export const saveAbsSettings = (sources) =>
  apiRequest("abs/settings", "PUT", { sources }, true);

export const getEvaluationContext = () =>
  apiRequest("abs/evaluation-context", "GET", null, true);

export const saveEvaluationContext = (context) =>
  apiRequest("abs/evaluation-context", "PUT", { context }, true);

export const discussEvaluationContext = (message) =>
  apiRequest("abs/evaluation-context/discuss", "POST", { message }, true);

export const listWriteKeys = () =>
  apiRequest("abs/write-keys", "GET", null, true);

export const createWriteKey = (name) =>
  apiRequest("abs/write-keys", "POST", { name: name || "default" }, true);

export const revokeWriteKey = (keyId) =>
  apiRequest(`abs/write-keys/${keyId}/revoke`, "POST", {}, true);
